var exports = {
  "o": "x7be19a29--d21afb--compact",
};

module.exports = exports;
